import React, { useEffect, useState } from 'react';
import {
	ApButtonSecondary,
	ApButtonTab,
	ApSecondaryNav,
} from '@alixpartners/ui-components';
import { SpendControllerPageWrapper, ContentDiv } from './styles.js';
import { CONFIG } from './routes.js';
import {
	NavLink,
	Redirect,
	Route,
	Switch,
} from 'react-router-dom/cjs/react-router-dom.min';
import Baseline from './Baseline/index.js';
import PreWorkShopTemplate from './PreWorkShop Template/index.js';
import Workshop from './Workshop/index.js';
import SavingsSignOff from './Savings Sign Off/SavingsSignOff.js';
import FinanceReport from './Finance Report/FinanceReport.js';
import withSpendControllerProviders from './HOCS/withSpendControllerProviders.js';
import { ActionItem } from 'Explore/TableView/styles.js';
import { CommonDialog } from './Components/CommonDialog/CommonDialog.js';
import { ImportData } from './Components/ImportData/ImportData.js';
import { useSpendControllerFiltersContext } from './Contexts/SpendControllerFiltersProvider.js';
import { Configure } from './Components/Configure/Configure.js';
import { ApSignalrConsumer } from '@alixpartners/ui-utils';
import { PERMISSIONS } from 'contexts/PermissionsContext/permissions.js';
import Tutorial from './Tutorial.js';
import {
	exportGLMasterData,
	exportSpendController,
} from 'utils/apiRequests.js';
import MicroTailLaunch from './Micro Tail Launch/MicroTailLaunch.js';
import { DataUpload } from './Components/Configure/DataUpload/DataUpload.js';
import DownloadingFile from './Components/Configure/DownloadingFile/DownloadingFile.js';
import { extractSelectedArrays } from './utils.js';
import {
	useHistory,
	useLocation,
} from 'react-router-dom/cjs/react-router-dom.js';

const ContentComponent = {
	baseline: Baseline,
	preworkshoptemplate: PreWorkShopTemplate,
	workshop: Workshop,
	savingSignOff: SavingsSignOff,
	financeReport: FinanceReport,
	microTailLaunch: MicroTailLaunch,
};
const UPLOAD_VISIBLE = ['spend-controller/baseline'];
const CONFIGURE_VISIBLE = [
	'spend-controller/baseline',
	'spend-controller/workshop',
];
const EXPORT_VISIBLE = ['spend-controller/finance-report'];
export const SpendController = props => {
	const { location, permissions } = props;
	const hasPermission = permission => permissions.includes(permission);
	const uidPattern = /^[a-zA-Z0-9]{12}[$%&][a-zA-Z0-9]{3}$/;
	const localLocation = useLocation();
	const history = useHistory();

	useEffect(
		() => {
			const params = new URLSearchParams(localLocation.search);
			const uid = params.get('UId');
			const currentPath = localLocation.pathname;
			if (uid !== null && !permissions.includes(PERMISSIONS.BaselineRead)) {
				if (uidPattern.test(uid)) {
					const storedUid = localStorage.getItem('spend_controller_uid');

					if (storedUid) {
						localStorage.removeItem('spend_controller_uid');
						localStorage.removeItem('allowed_routes');
					}

					localStorage.setItem('spend_controller_uid', uid);
					localStorage.setItem('allowed_routes', JSON.stringify([currentPath]));

					history.push(currentPath);
				} else {
					console.log('failed uid ');
					const allowedRoutes = JSON.parse(
						localStorage.getItem('allowed_routes') || '[]'
					);
					history.push(allowedRoutes[0]);
				}
			}
			// return () => {
			// 	localStorage.removeItem('spend_controller_uid');
			// 	localStorage.removeItem('allowed_routes');
			// };
		}, // eslint-disable-next-line
		[localLocation, history]
	);

	const allowedRoutes = JSON.parse(
		localStorage.getItem('allowed_routes') || '[]'
	);

	setTimeout(() => {
		localStorage.removeItem('spend_controller_uid');
		localStorage.removeItem('allowed_routes');
	}, 1800000);

	const isRouteAllowed = path => {
		return allowedRoutes.length === 0 || allowedRoutes.includes(path);
	};
	const shouldHideComponent =
		location.pathname === '/spend-controller/finance-report' ||
		(location.pathname === '/spend-controller/preworkshop-template' &&
			!hasPermission(PERMISSIONS.BaselineRead));

	const handleReturnType = () => {
		switch (location.pathname) {
			case '/spend-controller/preworkshop-template':
				return 2;
			case '/spend-controller/workshop':
				return 3;
			case '/spend-controller/saving-sign-off':
				return 4;
			case '/spend-controller/baseline':
				return 5;
			case '/spend-controller/micro-tail-launch':
				return 6;
			default:
				break;
		}
		return 2;
	};
	const [isTutorialOpen, setIsTutorialOpen] = useState(false);

	const steps = [
		{
			selector: '[data-tour="step-1"]',
			content: 'Here you can upload Data',
		},
		{
			selector: '[data-tour="step-2"]',
			content: 'Here you can apply filters',
		},
		{
			selector: '[data-tour="step-3"] ',
			content: 'These KPIs will refresh on filter change',
		},
		{
			selector: '[data-tour="step-4"]',
			content: 'These KPIs will refresh on filter change',
		},
		// Add more steps as needed
	];
	const [isImportModalOpen, setIsImportModalOpen] = useState(false);
	const [isUploadModalOpen, setUploadModalOpen] = useState(false);
	const [isDownloadModalOpen, setDownloadModalOpen] = useState(false);
	const [isConfigureModalOpen, setIsConfigureModalOpen] = useState(false);
	const hasSomePermissions = requiredSome => {
		return !requiredSome || requiredSome.some(i => permissions.includes(i));
	};
	const {
		handleSpendControllerFilters,
		setRefresh,
		setUploadRefresh,
		filters,
		spendType,
	} = useSpendControllerFiltersContext();
	const handleGLExport = async () => {
		await exportGLMasterData();
	};
	return (
		<SpendControllerPageWrapper>
			<ApSecondaryNav
				left={
					<React.Fragment>
						{CONFIG.map(({ label, path, requiredSome }) => {
							const routeAllowed = isRouteAllowed(path);
							if (!hasSomePermissions(requiredSome) || !routeAllowed) {
								return null;
							}

							return (
								<NavLink to={path} key={path}>
									<ApButtonTab isSelected={location.pathname.includes(path)}>
										{label}
									</ApButtonTab>
								</NavLink>
							);
						})}
						<ApSignalrConsumer
							message="SpendControllerEditTrigger"
							onMessage={() => {
								setRefresh(true);
							}}
						/>
						<ApSignalrConsumer
							message="SpendControllerUploadTrigger"
							onMessage={() => {
								setUploadRefresh(state => !state);
							}}
						/>
					</React.Fragment>
				}
				right={
					<React.Fragment>
						{!shouldHideComponent && (
							<>
								<ActionItem>
									<ApButtonSecondary
										// data-tour="step-1"
										onClick={async () => {
											setDownloadModalOpen(true);
											let tempFilters = Object.assign(
												{},
												extractSelectedArrays(filters)
											);
											tempFilters.tailSpendType = spendType;
											const typeValue = handleReturnType();
											tempFilters = typeValue === 5 ? {} : tempFilters;
											await exportSpendController({
												filters: tempFilters,
												type: typeValue,
											});
										}}
										iconName="download"
									>
										Export Data
									</ApButtonSecondary>
								</ActionItem>
								{UPLOAD_VISIBLE.some(
									element => !location.pathname.includes(element)
								) && (
									<ActionItem>
										<ApButtonSecondary //this is to upload current model
											// data-tour="step-1"
											onClick={() => setUploadModalOpen(true)}
											iconName="upload_outlined"
										>
											Import data
										</ApButtonSecondary>
									</ActionItem>
								)}
							</>
						)}
						{UPLOAD_VISIBLE.some(element =>
							location.pathname.includes(element)
						) && (
							<ActionItem>
								<ApButtonSecondary
									data-tour="step-1"
									onClick={() => {
										setIsImportModalOpen(true);
									}}
									iconName="upload_outlined"
								>
									Import data
								</ApButtonSecondary>
							</ActionItem>
						)}
						{EXPORT_VISIBLE.some(
							element =>
								!location.pathname.includes(element) &&
								permissions.includes(PERMISSIONS.BaselineRead) &&
								location.pathname !== '/spend-controller/workshop'
						) && (
							<ActionItem>
								<ApButtonSecondary
									onClick={() => setIsConfigureModalOpen(true)}
									iconName="settings"
								>
									Configure
								</ApButtonSecondary>
							</ActionItem>
						)}

						{EXPORT_VISIBLE.some(
							element =>
								location.pathname.includes(element) &&
								permissions.includes(PERMISSIONS.SpendControllerUpload)
						) && (
							<ActionItem>
								<ApButtonSecondary
									onClick={() => handleGLExport(true)}
									iconName="download"
								>
									Export GL
								</ApButtonSecondary>
							</ActionItem>
						)}
						{isTutorialOpen && (
							<Tutorial
								steps={steps}
								onClose={() => setIsTutorialOpen(false)}
							/>
						)}
					</React.Fragment>
				}
			/>
			<ContentDiv>
				<Switch>
					{CONFIG.map(({ name, path }) => {
						const routeAllowed = isRouteAllowed(path);
						return (
							routeAllowed && (
								<Route
									key={path}
									path={path}
									component={ContentComponent[name]}
								/>
							)
						);
					})}
					{allowedRoutes.length > 0 ? (
						<Redirect to={allowedRoutes[0]} />
					) : permissions.includes(PERMISSIONS.SpendControllerUser) ? (
						<Redirect to={CONFIG[1].path} />
					) : (
						<Redirect to={CONFIG[0].path} />
					)}
				</Switch>
			</ContentDiv>
			{isImportModalOpen && (
				<CommonDialog
					onClose={() => setIsImportModalOpen(false)}
					body={<ImportData fetchBudget={() => setIsImportModalOpen(false)} />}
					title="Import data"
					maxWidth={640}
					suppressFooter
				/>
			)}
			{isUploadModalOpen && (
				<CommonDialog
					onClose={() => setUploadModalOpen(false)}
					body={
						<DataUpload
							type={2}
							isAppend={false}
							fetchBudget={() => setUploadModalOpen(false)}
							location={location}
							baselineUploadType={2}
						/>
					}
					title="Upload data"
					maxWidth={640}
					suppressFooter
				/>
			)}
			{isDownloadModalOpen && (
				<CommonDialog
					onClose={() => setDownloadModalOpen(false)}
					body={<DownloadingFile />}
					title="Download data"
					maxWidth={640}
					suppressFooter
				/>
			)}
			{isConfigureModalOpen && (
				<CommonDialog
					onClose={() => setIsConfigureModalOpen(false)}
					body={
						<Configure fetchBudget={handleSpendControllerFilters} {...props} />
					}
					title="Configure Current Module"
					maxWidth={
						CONFIGURE_VISIBLE.some(element =>
							location.pathname.includes(element)
						)
							? 1250
							: 800
					}
					suppressFooter
				/>
			)}
		</SpendControllerPageWrapper>
		// </TourProvider>
	);
};

export default withSpendControllerProviders(SpendController);
